import { useState } from "react";

const useLocalStorage = <T,>(
  key: string,
  initialValue: T | null = null,
  // eslint-disable-next-line
): [T | null, (value: T | null) => void] => {
  const [storedValue, setStoredValue] = useState<T | null>(() => {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  });

  const setValue = (value: T | null): void => {
    setStoredValue(value);
    if (value !== null) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
  };

  return [storedValue, setValue];
};

export default useLocalStorage;
